import {
  useConfiguration,
  initializeConfig,
} from '../../../../store/configurationStore';
import {
  ConfigurationTemplate,
  InstrumentConfig,
  ALL_UI_INSTRUMENT_TYPES,
  ConfigurationSection,
} from '../types';
import { getSectionsForInstrumentType } from '../configs/sectionConfigs';

export const useTemplateManagement = () => {
  const {
    templates,
    activeTemplateId,
    setActiveTemplate,
    addTemplate,
    updateTemplate,
    deleteTemplate,
  } = useConfiguration();

  // Get the active template
  const activeTemplate = templates.find(t => t.id === activeTemplateId) || null;

  // Create default instrument configs for a new template
  const createDefaultInstrumentConfigs = (): InstrumentConfig[] => {
    return ALL_UI_INSTRUMENT_TYPES.map(instrumentType => {
      const sectionConfigs = getSectionsForInstrumentType(instrumentType);

      // Create visible sections
      const sections: ConfigurationSection[] = sectionConfigs.map(
        sectionConfig => ({
          id: sectionConfig.id,
          title: sectionConfig.title,
          type: sectionConfig.type,
          config: initializeConfig(sectionConfig.type, sectionConfig.id),
        })
      );

      return {
        instrumentType,
        sections,
      };
    });
  };

  // Create a new template
  const createTemplate = (name: string): void => {
    const newTemplate: ConfigurationTemplate = {
      id: `template-${Date.now()}`,
      name,
      instrumentConfigs: createDefaultInstrumentConfigs(),
    };

    addTemplate(newTemplate);
    setActiveTemplate(newTemplate.id);
  };

  // Select a template
  const selectTemplate = (templateId: string): void => {
    setActiveTemplate(templateId);
  };

  // Update a template
  const updateTemplateDetails = (
    templateId: string,
    updates: Partial<ConfigurationTemplate>
  ): void => {
    updateTemplate(templateId, updates);
  };

  // Delete a template
  const removeTemplate = (templateId: string): void => {
    deleteTemplate(templateId);
  };

  return {
    templates,
    activeTemplate,
    createTemplate,
    selectTemplate,
    updateTemplateDetails,
    removeTemplate,
  };
};
